import { render, staticRenderFns } from "./ItemFolder.vue?vue&type=template&id=60bd96f4&scoped=true"
import script from "./ItemFolder.vue?vue&type=script&lang=js"
export * from "./ItemFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd96f4",
  null
  
)

export default component.exports